import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getInteractionModality } from '@react-aria/interactions';
import PropTypes from 'prop-types';
import React__default, { useRef, useEffect } from 'react';
import { useSelectedItems } from './use-selected-items.hook.js';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { PopoverDialog } from '../popover/popover-dialog.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { useIsomorphicLayoutEffect } from '../../hooks/use-isomorphic-layout-effect.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

({
  /**
  * Set to "true" if the Listbox Popover is rendering inside a Modal.
  */
  inModal: PropTypes.bool
});
var ListboxPopover = renderWithRef('ListboxPopover', {}, function (props, ref) {
  var children = props.children,
      className = props.className,
      isNonModal = props.isNonModal;

  var _useSwanPopover = useSwanPopover(),
      overlayState = _useSwanPopover.overlayState,
      triggerRef = _useSwanPopover.triggerRef,
      fullWidth = _useSwanPopover.fullWidth;

  var popoverRef = useRef(null);
  var combinedRef = assignRefs(ref, popoverRef);

  var _useSelectedItems = useSelectedItems(),
      selectedItems = _useSelectedItems.selectedItems;

  var classes = new Set(['swan-listbox-popover']);
  if (className) classes.add(className);
  /**
  * Fixes this react-aria bug where the selected option does not scroll into view when the popover is opened
  * https://github.com/adobe/react-spectrum/issues/4974
  * https://vistaprint.atlassian.net/browse/DSYS-2095
  */

  useEffect(function () {
    if (overlayState.isOpen && selectedItems.length > 0) {
      var _selectedItems_;

      var activeElement = document.activeElement;

      if ( // verify that the actively focused element is the selected option
      (activeElement === null || activeElement === void 0 ? void 0 : activeElement.getAttribute('data-key')) === ((_selectedItems_ = selectedItems[0]) === null || _selectedItems_ === void 0 ? void 0 : _selectedItems_.key) && (activeElement === null || activeElement === void 0 ? void 0 : activeElement.getAttribute('role')) === 'option' && // the issue only effects mouse users, not keyboard ones
      getInteractionModality() === 'pointer') {
        activeElement === null || activeElement === void 0 ? void 0 : activeElement.scrollIntoView({
          block: 'nearest'
        });
      }
    }
  }, [selectedItems, overlayState.isOpen]);
  useIsomorphicLayoutEffect(function () {
    var popoverEl = popoverRef.current;
    var triggerEl = triggerRef.current;

    if (overlayState.isOpen && fullWidth && triggerEl && popoverEl) {
      var _triggerEl$getBoundin = triggerEl.getBoundingClientRect(),
          width = _triggerEl$getBoundin.width;

      popoverEl.style.width = "".concat(width, "px");
      popoverEl.style.minWidth = "".concat(width, "px");
      popoverEl.style.maxWidth = "".concat(width, "px");
    }
  }, [overlayState.isOpen, fullWidth, triggerRef]);
  return overlayState.isOpen ? /*#__PURE__*/React__default.createElement(PopoverContentInternal, _object_spread_props(_object_spread({}, props), {
    ref: combinedRef,
    className: _toConsumableArray(classes).join(' ')
  }), isNonModal ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children) : /*#__PURE__*/React__default.createElement(PopoverDialog, null, children)) :
  /* the listbox list needs to be rendered in the dom for the items to be registered with the parent listbox */

  /*#__PURE__*/
  React__default.createElement("div", {
    "aria-hidden": "true",
    className: "swan-display-none"
  }, children);
});
ListboxPopover.defaultProps = {
  placement: 'bottom start',
  hideArrow: true
};
export { ListboxPopover };